import React from 'react';

interface ReactQuillEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Simple rich-text compatible editor. Uses textarea - content is stored as plain text.
 * For HTML display, we wrap content in a div (posts support basic HTML from backend).
 * Compatible with React 18/19 (react-quill uses deprecated findDOMNode).
 */
const ReactQuillEditor: React.FC<ReactQuillEditorProps> = ({
  value,
  onChange,
  placeholder,
  className,
  style
}) => {
  return (
    <div className={className} style={{ minHeight: '200px', ...style }}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
        style={{ minHeight: '200px' }}
      />
    </div>
  );
};

export default ReactQuillEditor;
